import { api } from "@/api";

export async function deleteFavoriteMatch(matchId: number) {
  const res = await api.client.delete(`/favorite-matches/${matchId}`);
  return res.data;
}
